"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathMixedTypes = void 0;
exports.pathMixedTypes = [
    {
        patientMrn: null,
        dateOfService: 1714608000000,
        providerNumber: "130234234",
        placerOrderNumber: "",
        fillerOrderNumber: "PS-21-174482342",
        encounterNumber: "",
        encounterGuid: null,
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "PATHOLOGY",
        documentCategory: "DFT_IN",
        messageCategory: "HL7",
        documentStatus: "FINAL",
        documentName: "dft1.txt",
        documentDescription: null,
        mimeType: "text/plain",
        contentLength: 357,
        externalId: "240507010012_707_1",
        documentGuid: {
            uuid: "cb89f36c-0a52-4bce-a9aa-5efebd59d3f1"
        },
        documentId: 62485481,
        messageId: "240507010012_706_1",
        sourceName: "Powerpath",
        sourceType: "HL7",
        serviceLine: "Pathology",
        businessKey: "PS-21-174482342",
        additionalInfo: null,
        uniqueDocumentNumber: null,
        hl7MessageDirection: "INBOUND",
        hl7MessageType: "DFT",
        id: 62485481
    },
    {
        patientMrn: null,
        dateOfService: 1714608000000,
        providerNumber: "07705",
        placerOrderNumber: null,
        fillerOrderNumber: "PS-21-174482342",
        encounterNumber: "PS-21-17448",
        encounterGuid: null,
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "PATHOLOGY",
        documentCategory: "DFT_EHR",
        messageCategory: null,
        documentStatus: null,
        documentName: "dft1.txt",
        documentDescription: null,
        mimeType: "text/plain",
        contentLength: 409,
        externalId: "C-PATH-76788119-1",
        documentGuid: {
            uuid: "f1a2806f-8960-45c1-9f3c-bb53ffe684a8"
        },
        documentId: 62672151,
        messageId: null,
        sourceName: null,
        sourceType: null,
        serviceLine: "Pathology",
        businessKey: null,
        additionalInfo: null,
        uniqueDocumentNumber: null,
        hl7MessageDirection: "OUTBOUND",
        hl7MessageType: null,
        id: 62672151
    }
];
//# sourceMappingURL=mixed-types.js.map